<div class="flex__child--auto flex--column" data-test="flock">
  <router-outlet></router-outlet>
</div>
